



















































































































































import { gearApplySearchApi } from '@/api/index';
import { Component, Vue } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import Hamburger from '@/components/Hamburger/index.vue';
import LangSelect from '@/components/GearLang/index.vue';
import { getStuDataApi } from '@/api/student-management'
import { uploadLogolIconUrlApi, getAgentLogolIconUrlApi } from '@/api/index'

@Component({
  name: 'Navbar',
  components: {
    Hamburger,
    LangSelect,
  },
})
export default class extends Vue {
  public companyLogo = require('@/assets/image/common/default-logo.png');
  public search: string = '';
  public offerItemInfos: any = [];
  public studentInfos: any = [];
  public firstOfferItemInfoId: number = 0;
  public firstStudentInfoId: number = 0;
  public lastOfferItemInfoId: number = 0;
  public lastStudentInfoId: number = 0;
  public showOfferViewMore: boolean = false;
  public showStudentViewMore: boolean = false;
  public originCompanyName: string = UserModule.agentCompanyName;
  public originUserName: string = UserModule.name;

  get sidebar() {
    return AppModule.sidebar;
  }

  get innerAccount() {
    return UserModule.issueInnerAccount ? this.$t('navbar.innerAccount') : '';
  }

  public containsNonChineseChars(str: string) {
      const regex = /[^\p{Script=Han}]/gu;
      return regex.test(str);
  }

  public mounted() {
    this.getCompantLogo()
  }

  public toggleSideBar() {
    AppModule.ToggleSideBar(true);
    const elem = document.querySelector('.stu-all-form-info');
    const navComp = document.querySelector('.nav-comp') as HTMLDivElement
    if (elem && navComp) {
      if (this.sidebar.opened === false) {
        navComp.style.left = 74 + 'px';
      } else {
        navComp.style.left = 250 + 'px';
      }
    }
  }

  public async logout() {
    await UserModule.LogOut().catch((err) => err);
    this.$router.push(`/login?redirect=${this.$route.fullPath}`)
  }

  public async getCompantLogo() {
    try {
      const { data } = await getAgentLogolIconUrlApi();
      if (data && data.data.filePath) {
        this.companyLogo = UserModule.publicFilesUrl + data.data.filePath;
      }
    } catch (error) {
      //
    }
  }

  public async updateLogo(params: any) {
    try {
      const file = params.file;
      const formData =  new FormData();
      formData.append('files', file);
      const { data } = await uploadLogolIconUrlApi(formData);
      this.companyLogo = UserModule.publicFilesUrl + data.data.filePath;
    } catch(err) {
      //
    }
  }

  public beforeUpload(file: any) {
    const isJPG = ['image/png', 'image/gif', 'image/jpg', 'image/jpeg', 'image/bmp', 'image/webp', 'image/svg'].includes(file.type)
    if (!isJPG) {
      this.$message.error(this.$t('navbar.logoFormatError') as string);
    }
    return isJPG;
  }

  public async querySearchAsync(queryString: string, cb: any) {
    if (queryString) {
      this.search = queryString;
      const { data } = await gearApplySearchApi(queryString);
      const offerItemInfos = data.data.offerItemInfos;
      const studentInfos = data.data.studentInfos;
      if((offerItemInfos && !offerItemInfos.length) && (offerItemInfos && !studentInfos.length)) {
        this.$message({
          type: 'warning',
          message: this.$t('index.noSearchResults') as string,
          offset: 90
        });
      }
      if (offerItemInfos && offerItemInfos.length > 5) {
        this.showOfferViewMore = true;
      }
      if (studentInfos && studentInfos.length > 5) {
        this.showStudentViewMore = true;
      }
      if (offerItemInfos && offerItemInfos.length && studentInfos && studentInfos.length) {
        const arr1 = offerItemInfos.slice(0, 5);
        const arr2 = studentInfos.slice(0, 5);
        this.firstOfferItemInfoId = arr1[0].itemId;
        this.firstStudentInfoId = arr2[0].studentId;
        this.lastOfferItemInfoId = arr1[arr1.length - 1].itemId;
        this.lastStudentInfoId = arr2[arr2.length - 1].studentId;
        cb([...arr1, ...arr2]);
      } else if (offerItemInfos && offerItemInfos.length) {
        const arr = offerItemInfos.slice(0, 5);
        this.firstOfferItemInfoId = arr[0].itemId;
        this.lastOfferItemInfoId = arr[arr.length - 1].itemId;
        cb([...arr]);
      } else if (studentInfos && studentInfos.length) {
        const arr = studentInfos.slice(0, 5);
        this.firstStudentInfoId = arr[0].studentId;
        this.lastStudentInfoId = arr[arr.length - 1].studentId;
        cb([...arr]);
      } else {
        cb([])
      }
    } else {
      cb([]);
    }
  }

  public viewPdf() {
    window.open('https://cosimg.geteducation.net/gear/GEAROperationManual.pdf');
  }

  public async viewDetail(item: any, tab: string) {
    const id = item.studentId;
    const source = item.stuSource;
    try {
      const { data } = await getStuDataApi(id, source);
      const stu = `${data.data.lastName} ${data.data.firstName}`;
      sessionStorage.setItem('tab', tab);
      if (tab === 'applyDetail') {
        const itemId = item.itemId;
        this.$router.replace({ name: 'studentInformation', query: { source, itemId, stu }, params: { id } });
      } else {
        this.$router.replace({ name: 'studentInformation', query: { source, stu }, params: { id } });
      }
    } catch (err) {
      //
    }
  }

  public handleViewMore(page: string) {
    this.$router.push({
      name: page, query: { keyword: this.search }
    });
  }
}
